import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../services/analytics';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top
        window.scrollTo(0, 0);

        // Log page view
        const pageNames = {
            '/': 'Home',
            '/about': 'About Us',
            '/how-it-works': 'How It Works',
            '/faq': 'FAQ'
        };

        const pageName = pageNames[pathname] || 'Unknown';
        logPageView(pageName, document.title);
    }, [pathname]);

    return null;
}

export default ScrollToTop;
